import { generateUtilityClasses, styled } from '@mui/material';

export const classes = generateUtilityClasses('ShopDialog', ['image']);

export const StyledImage = styled('img')(() => ({
  [`&.${classes.image}`]: {
    maxWidth: 200,
  },
}));
